import React from 'react';
import instructVisual from '../images/instruct-v.png';
import instructOlfactory from '../images/instruct-o.png';
import instructTaste from '../images/instruct-g.png';
import instructNote from '../images/instruct-n.png';

// En escritorio las instrucciones son la ilustracion con bocadillo (la imagen).
// En movil se muestran como texto para que se lea a un tamano decente.
const content = {
    visual: {
        image: instructVisual,
        paragraphs: [
            'Selecciona una respuesta para clasificar la intensidad de color y otra para describir el color del vino.',
            'Puedes utilizar el botón de pistas si necesitas ayuda.',
            'Cuando hayas seleccionado ambas respuestas correctamente, se activará la flecha de avance y podrás continuar al siguiente paso.',
            'Si no te permite continuar, es porque no has seleccionado todas las respuestas necesarias.',
        ],
    },
    olfactory: {
        image: instructOlfactory,
        paragraphs: [
            'Selecciona una respuesta para clasificar la intensidad del aroma.',
            'A continuación, selecciona 3 aromas primarios, 2 secundarios y 1 terciario. Ten en cuenta que existe más de una combinación correcta.',
            'Puedes utilizar la tabla de aromas desde el botón de pistas si necesitas ayuda.',
            'Cuando hayas seleccionado todas las respuestas correctamente, se activará la flecha de avance y podrás continuar al siguiente paso.',
            'Si no te permite continuar, es porque no has seleccionado todas las respuestas necesarias.',
        ],
    },
    taste: {
        image: instructTaste,
        paragraphs: [
            'Desplaza las barras para indicar la intensidad de cada una de las variables.',
            'Puedes utilizar la tabla desde el botón de pistas si necesitas ayuda.',
            'Cuando hayas seleccionado todas las respuestas correctamente, se activará la flecha de avance y podrás continuar al siguiente paso.',
            'Si no te permite continuar, es porque no has seleccionado todas las respuestas necesarias.',
        ],
    },
    note: {
        image: instructNote,
        paragraphs: [
            'Utiliza tu nota de cata para intentar identificar la variedad, el país, la región, la bodega, la marca, la añada y el precio del vino.',
            'Todos los vinos utilizados en el juego pertenecen a la carta del Club Matador.',
            'Cuando hayas seleccionado todas las respuestas correctamente, se activará la flecha de avance y podrás continuar al siguiente paso.',
            'Si no te permite continuar, es porque no has seleccionado todas las respuestas necesarias.',
        ],
    },
};

export const handleQuitInstructions = () => {
    const instructionsDiv = document.getElementById('instructions-div');
    if (instructionsDiv) {
        instructionsDiv.style.display = 'none';
    }
};

const Instructions = ({ phase }) => {
    const { image, paragraphs } = content[phase];

    return (
        <div className="overlay" id="instructions-div" onClick={handleQuitInstructions}>
            <img src={image} alt="Instrucciones" className="centered-image dekstop" />
            <div className="instructions-card mobile" onClick={(e) => e.stopPropagation()}>
                <button
                    type="button"
                    className="instructions-close"
                    aria-label="Cerrar"
                    onClick={handleQuitInstructions}
                >
                    &#10005;
                </button>
                <div className="instructions-title">Instrucciones:</div>
                {paragraphs.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                ))}
            </div>
        </div>
    );
};

export default Instructions;
